import React from "react";
import Banner from "../components/ContactUs/Banner";
import HelpText from "../components/ContactUs/HelpText";
import WaysToContact from "../components/ContactUs/WaysToContact";
import Features from "../components/ContactUs/Features";

const ContactUs = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "5rem",
      }}
    >
      <Banner
        header="Contact Us"
        text="Compare prices, order and buy mobile phones, electronics,
              appliances, and accessories online for hassle-free delivery to
              your home."
      />
      <HelpText
        header="Need Help?"
        text="We would love to hear from you. We are here for you 24/7."
      />
      <WaysToContact />
    </div>
  );
};

export default ContactUs;
